// usePostRequest.js
import { useState } from "react";

const useRequests = () => {
  const [data, setData] = useState<any>({});
  const [error, setError] = useState(-1);
  const [loading, setLoading] = useState(false);
  const [code, setStatusCode] = useState<number>();

  const baseUrl = process.env.REACT_APP_API_URL;
  const headers = {
    "Content-Type": "application/json",
  };

  const _url = (url: string): string => {
    if (url.startsWith("/")) {
      return `${baseUrl}${url}`;
    } else if (url.startsWith("http")) {
      return url;
    }
    return `${baseUrl}/${url}`;
  };

  const get = async (url: string) => {
    const response = fetch(_url(url), {
      headers,
      credentials: "include",
    });
    return response;
  };

  const post = async (url: string, body?: any, json: any = null) => {
    setLoading(true);

    if (body && !json) {
      headers["Content-Type"] = "application/x-www-form-urlencoded";
    }

    try {
      const response = await fetch(_url(url), {
        method: "POST",
        headers,
        credentials: "include",
        body: json !== null ? JSON.stringify(json) : body,
      });

      setStatusCode(response.status);
      const data: any = await response.json();
      setData(data);
      return { data, status: response.status };
    } catch (error: any) {
      setError(error);
    } finally {
      setLoading(false);
    }
    return {};
  };

  return { data, error, loading, code, post, get };
};

export default useRequests;
